import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type MetricsService from 'garaje/services/metrics';
import type PageVisibilityTrackerService from 'garaje/services/page-visibility-tracker';

export default class LocationOverviewManageEventLogRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare metrics: MetricsService;
  @service declare pageVisibilityTracker: PageVisibilityTrackerService;

  titleToken = 'Event Log';

  private sessionId = 'global-event-log';

  beforeModel(): void {
    if (this.abilities.cannot('visit global event log in manage-settings')) {
      this.router.transitionTo('unauthorized');
    }
  }

  afterModel(): void {
    this.metrics.trackPage('Global Event Log Page', {
      context: 'global_event_log',
      page_type: 'event_log',
      scope: 'global',
    });

    this.pageVisibilityTracker.startTracking(this.sessionId, 'global_event_log', 'global', 'Event Log Page Time Spent');
  }

  deactivate(): void {
    this.pageVisibilityTracker.stopTracking(this.sessionId);
  }
}
